import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServicePropertyAlert {
  getPropertyAlert(alertID, propertyID) {
    var config = {
      url: "/property/" + propertyID + "/alert/" + alertID,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyAlerts(id) {
    var config = {
      url: "/property/" + id + "/alert",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  editPropertyAlert(propertyID, payload) {
    var config = {
      url: "/property/" + propertyID + "/alert/" + payload.id,
      method: "put",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: payload
    };
    return apiService.api(config);
  }

  deleteAlert(propertyID, alertID) {
    var config = {
      url: "/property/" + propertyID + "/alert/" + alertID,
      method: "delete",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }
}
